import PropTypes from 'prop-types'
import exact from 'prop-types-exact'
import React from 'react'
import '../../styles/modal.pcss'
import { REDIRECT_MODAL } from './Modals'
import GenericModal from './GenericModal'
import Countdown from '../../components/util/Countdown'

const RedirectModal = ({ onClose, itemLink, itemTitle }) => {

  const redirect = () => {
    window.location.href = itemLink
  }

  return (
    <GenericModal
      modalId={ REDIRECT_MODAL }
      onClose={ onClose }
      okButtonTxt='Jatka uutiseen'
      onOkClick={ redirect }
      cancelButtonTxt='Jää amppareihin'
    >
      <Countdown time={ 12000 } timeStep={ 1000 } onComplete={ redirect }>
        <span>s</span>
      </Countdown>
      <p>
        Ohjataan uutiseen: <i>{ '“' + itemTitle + '”' }</i>
      </p>
      <br />
      <p>
        Halutessasi voit jäädä uudistuneeseen Ampparit.comiin tutustumaan reaaliaikaiseen uutistarjontaan!
      </p>
    </GenericModal>
  )
}

RedirectModal.propTypes = exact({
  itemLink: PropTypes.string.isRequired,
  itemTitle: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
})

export default RedirectModal
